import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { postUsers } from "components/axios/userAxios";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import CustomFormEnumSelect from "components/select/CustomFormEnumSelect";
import { useEnumApi } from "contexts/EnumApiContext";
import { getCheckDupleEmail, getCheckDupleLoginId } from "components/axios/joinAxios";
import { useTranslation } from "react-i18next";
import { ROLE } from "data/data";
import { writeAuditLog } from "components/axios/auditLogger";

const UserAddSetting = () => {
  const { t } = useTranslation();
  const { getEnumValueByEnumName } = useEnumApi();

  // modal 관련
  const { openModal } = useModals();
  const handleAlertClick = (alertMessage) => {
    openModal(modals.alertModal, {
      onClose : () => {
        //console.log(1111);
      },
      message: alertMessage,
    });
  };

  //console.log(window.location.search);
  //let qs = queryString.parse(window.location.search);
  //console.log(qs);

  const { control, register, handleSubmit, reset, formState : {isDirty, errors } } = useForm({});

  // const [statusTypes] = useState([{code:1,title:"정상"},{code:0,title:"정지"}]);
  const [isCheck, setIsCheck] = useState(false);
  const [userId, setUserId] = useState('');
  const [email, setEmail] = useState('');
  const [isEmailCheck, setIsEmailCheck] = useState(false);

  const roleTypes = useMemo(()=>{
      return getEnumValueByEnumName('RoleType').filter((role)=>(role.code !== ROLE.AD.code && role.code !== ROLE.WK.code 
        && role.code !== ROLE.MO.code && role.code !== ROLE.CS.code))
  },[getEnumValueByEnumName])

  //email& 비밀번호 정규식  
  const emailRegEx = /^[A-Za-z0-9]([-_.]?[A-Za-z0-9])*@[A-Za-z0-9]([-_.]?[A-Za-z0-9])*\.[A-Za-z]{2,3}$/i;
  // const passwordRegEx = /^[A-Za-z0-9]{8,20}$/
  const passwordRegEx = /^\S{8,20}$/; // 설명: 공백문자 없이 8~20자 (공백 포함 불허)

  // 등록
  let onSubmit = (data) => {
    console.log(data);

    const roleCode      = data.roleCode;
    const name      = data.name;
    const loginId   = data.loginId;
    const password  = data.password;
    const password2 = data.password2;
    const contact   = data.contact;
    const email     = data.email;
    const emailRecvYn = data.emailRecvYn;
    const status = data.status;

    console.log('write');
    console.log("role : " + roleCode);
    console.log("name : " + name);
    console.log("loginId : " + loginId);
    console.log("password : " + password);
    console.log("password2 : " + password2);
    console.log("contact : " + contact);
    console.log("email : " + email);
    console.log("status : " + status);
    console.log("isCheck : " + isCheck);

    if (!isCheck) {
      handleAlertClick(t('message.common.alert.id.duplication.check'));
      return;
    }

    if (password !== password2) {
      handleAlertClick(t('message.common.alert.password.check.re-enter'));
      return;
    }

    let body = {
      id : null,
      role : roleCode,
      name,
      loginId,
      password,
      // telNo : '000-0000-0000',
      contact,
      email,
      // emailRecvYn,
      loginActiveStatus : status
    };

    console.log(body)

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
        postUsers(body)
        .then(async(res)=>{
          // console.log(res)
          await writeAuditLog({
              actionType: "CREATE",
              targetType: "USER",
              targetId: res.id,
              targetName: loginId,
              
              apiUrl : `/api/users`,
              requestMethod : 'POST',
              // summary: t('message.common.log.memo.user.create'),
              summary: 'message.common.log.memo.user.create',
              payload : body
          });
          
          handleAlertClick(t('message.common.alert.write.done'));
          document.location.href = '/setting/user/user/modify/'+res.id+window.location.search;
        }).catch((err)=>{
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
        console.log('close');
      },
      message: t('message.common.alert.write.question'),
     });
    //  reset();
  };

  const dupleCheckId = () => {
    if (!userId) {
      handleAlertClick(t('message.common.alert.id.input'));
      return;
    }

    getCheckDupleLoginId({loginId:userId}).then((data)=>{
      setIsCheck(!data);
      if (data) {
        handleAlertClick(t('message.common.alert.id.use.other.id.input'));
      } else {
        handleAlertClick(t('message.common.alert.id.available'));
      }
    }).catch((err)=>{
      console.log(err);
      handleAlertClick(err.response?.data?.message || err.message);
    })
  }
  
  const dupleCheckEmail = () => {
    if (!email) {
      handleAlertClick(t('message.common.error.text.email.input'));
      return;
    }

    getCheckDupleEmail({email:email}).then((data)=>{
      setIsEmailCheck(!data);
      if (data) {
        handleAlertClick(t('message.common.alert.email.use.other.email.input'));
      } else {
        handleAlertClick(t('message.common.alert.email.available'));
        
      }
    }).catch((err)=>{
      console.log(err);
      handleAlertClick(err.response?.data?.message || err.message);
    })
  }

  return (
    <div>
      {/* <div className="mro_search">
        <h5 className="mro_m_left" style={{color:"#000"}}>* 사용자 관리 등록</h5>
      </div> */}

      <form onSubmit={handleSubmit(onSubmit)}>
        <TableContainer>
          <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width" style={{borderTop:"2px solid #a2a2a2"}} >
            <TableBody>
              <TableRow>
                <TableCell className="th">{t('message.common.subtitle.authority')}</TableCell>
                <TableCell className="email_pl">
                  <Controller
                    name="roleCode"
                    control={control}
                    render={({ field:{ name }}) => (
                      <CustomFormEnumSelect
                        style={{ minWidth: '90%' }}
                        label={t('message.common.subtitle.authority')}
                        register={register}
                        name={name}
                        requiredMessage={t('message.common.error.text.authority.select')}
                        defaultValue={''}
                        key={'roleCode'}
                        list={roleTypes}
                      />
                    )}
                    rules={{ required: true }}
                  />
                  {errors.roleCode && <small role="alert"><br></br>{errors.roleCode.message}</small>}
                </TableCell>
                <TableCell className="th">{t('message.common.subtitle.name')}</TableCell>
                <TableCell>
                  <TextField id="userName" 
                  aria-invalid={!isDirty ? undefined : errors.name ? "true" : "false"}
                  defaultValue={''}
                  key={'userName'}
                  {...register("name", {
                    required : t('message.common.error.text.name.input')
                  })} 
                  sx={{ m: 1, minWidth: '90%' }} 
                  />
                  {errors.name && <small role="alert"><br></br>{errors.name.message}</small>}
                </TableCell>
                <TableCell className="th">{t('login.id')}</TableCell>
                <TableCell>
                  <TextField id="loginId" 
                  aria-invalid={!isDirty ? undefined : errors.loginId ? "true" : "false"}
                  {...register("loginId", {
                    required : t('message.common.error.text.id.input')
                  })} 
                  defaultValue={''}
                  key={'loginId'}
                  sx={{ m: 1, minWidth: '60%', width: '60%' }}
                  onClick={()=>{setIsCheck(false);}}
                  onChange={(event) => {setUserId(event.target.value); setIsCheck(false);}} />
                  <Button variant="contained" color="primary" size="small" sx={{top:"12px"}} onClick={()=>{dupleCheckId()}}>{t('message.common.btn.duplication.check')}</Button>
                  {errors.loginId && <small role="alert"><br></br>{errors.loginId.message}</small>}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="th">{t('message.common.subtitle.password')}</TableCell>
                <TableCell>
                  <TextField id="password" 
                  aria-invalid={!isDirty ? undefined : errors.password ? "true" : "false"}
                  {...register("password", {
                    required : t('message.common.error.text.password.input'),
                    pattern : {
                      value : passwordRegEx,
                      message : "invalid password"
                    }
                  })} 
                  type="password"
                  sx={{ m: 1, minWidth: '90%' }} />
                  {errors.password && <small role="alert"><br></br>{errors.password.message}</small>}
                </TableCell>
                <TableCell className="th">{t('message.common.subtitle.password.confirm')}</TableCell>
                <TableCell>
                  <TextField id="password2" 
                  aria-invalid={!isDirty ? undefined : errors.password2 ? "true" : "false"}
                  {...register("password2", {
                    required : t('message.common.error.text.password.check.re-enter'),
                    pattern : {
                      value : passwordRegEx,
                      message : "invalid password"
                    }
                  })} 
                  type="password"
                  sx={{ m: 1, minWidth: '90%' }} />
                  {errors.password2 && <small role="alert"><br></br>{errors.password2.message}</small>}
                </TableCell>
                <TableCell className="th">{t('message.common.subtitle.company.contact')}</TableCell>
                <TableCell className="email_pl">
                  <TextField id="contact" 
                      key={'contact'}
                      {...register("contact", {
                      })} 
                      sx={{ m: 1, minWidth: '90%' }} 
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="th">{t('message.common.subtitle.email')}</TableCell>
                <TableCell colSpan={3} className="email_pl">
                  <TextField id="email" 
                    aria-invalid={!isDirty ? undefined : errors.email ? "true" : "false"}
                    {...register("email", {
                      required : t('message.common.error.text.email.input'),
                      pattern : {
                        value : emailRegEx,
                        message : "invalid email address"
                      }
                    })} 
                    defaultValue={''}
                    sx={{ m: 1, minWidth: '70%' }}
                    onClick={()=>{setIsEmailCheck(false);}}
                    onChange={(event) => {setEmail(event.target.value); setIsEmailCheck(false);}}
                  />
                  <Button variant="contained" color="primary" size="small" sx={{top:"12px"}} onClick={()=>{dupleCheckEmail()}}>{t('message.common.btn.duplication.check')}</Button>
                  {errors.email && <small role="alert" style={{whiteSpace:"pre-wrap"}}><br></br>{errors.email.message}</small>}
                </TableCell>
                <TableCell className="th">{t('message.common.subtitle.status')}</TableCell>
                <TableCell className="email_pl">
                  <Controller
                    control={control}
                    name="status"
                    render={({ field: {name} }) => (
                      <CustomFormEnumSelect
                        style={{ minWidth: '90%' }}
                        label={t('message.common.subtitle.status')}
                        register={register}
                        name={name}
                        requiredMessage={t('message.common.error.text.status.select')}
                        list={getEnumValueByEnumName('ActiveStatus')}
                      />
                    )}
                    rules={{ required: true }}
                  />
                  {errors.status && <small role="alert"><br></br>{errors.status.message}</small>}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </form>

      <div className="btn_area" style={{marginTop:"10px", display:"flex", justifyContent:"space-between"}}>
        <div><Link to={'/setting/user/user'+window.location.search}><Button variant="contained" color="primary" style={{backgroundColor:"#333"}}>{t('message.common.btn.list')}</Button></Link></div>
        <div>
          <Button variant="contained" color="primary" onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</Button>
        </div>
      </div>
    </div>
  )
}
 
export default UserAddSetting;